<div class="document" *ngIf="document" button="true" mode="md">
  <div class="document__row-1" (click)="onDocumentClick()">
    <div class="document__icon">
      <img [src]="documentIconUrl ? documentIconUrl : documentIconByMimeType()" [alt]="document.mimeType"/>
    </div>
    <div class="document__name dark mapfre-fw-500">
      {{ document.name }}<span class="document__size medium-dark" *ngIf="showDocumentSize">({{ document.size | bytes: 2 | lowercase }})</span>
    </div>
  </div>
  <div class="document__row-2">
    <div
      class="document__buttons"
      *ngIf="showButtonDownload || showButtonDelete"
    >
      <ion-button
        class="document__button button-download"
        *ngIf="showButtonDownload"
        color="semi-light"
        fill="clear"
        (click)="onDocumentDownload()"
      >
        <img src="assets/images/download-arrow.svg" />
      </ion-button>
      <ion-button
        class="document__button button-delete"
        *ngIf="showButtonDelete"
        color="semi-light"
        fill="clear"
        (click)="onDocumentDelete()"
      >
        <img src="assets/images/delete.svg" />
      </ion-button>
    </div>
  </div>
</div>
